define('base/region',['require','exports','module','base/class','base/vent'],function(require, exports, module) {
  "use strict";

  var Class = require("base/class");

  // just for initialization
  require("base/vent");

  var Region = Class.extend({
    constructor: function(options) {
      options = options || {};
      this.$el = options.$el;
      Region.__super__.constructor.apply(this, arguments);
    },
    setElement: function($el) {
      this.$el = $el;
      if (this.currentView) {
        this.currentView.$el.detach();
        this.$el.empty().append(this.currentView.$el);
      } else if (this._pendingView) {
        this.show(this._pendingView);
        this._pendingView = undefined;
      }
    },
    delegateEvents: function() {
      if (this.currentView) {
        this.currentView.delegateEvents();
      }
    },
    show: function(view, options) {
      options = options || {};
      if (!this.$el || this.$el.length === 0) { this._pendingView = view; return; }
      if (this.currentView !== view || options.force) {
        this.close();
        this.open(view.render());
        // WARNING: don't remember why this was here,
        // so I'm commenting it to see if somethig else
        // breaks.
        // view.delegateEvents();
        this.currentView = view;
        this.currentView.triggerMethod("show");
      }
      return this.currentView;
    },
    showInstance: function(ViewConstructor, viewOptions, options) {
      options = options || {};
      if (!this.currentView || this.currentView.constructor !== ViewConstructor || options.force) {
        this.show(new ViewConstructor(viewOptions), options);
      }
      return this.currentView;
    },
    close: function(view) {
      view = arguments.length === 0? this.currentView : view;
      if (view) {
        view.triggerMethod("close");
        view.remove();
      }
    },
    open: function(view) {
      this.$el.empty().html(view.el);
    }
  });

  module.exports = Region;

});

